angular.module('app.filters')
  .filter(
        'firmsTypeAheadFilter',
        function() {
            return function(allFirms, query) {
                allFirms = allFirms || [];

                var firmName = '',
                firmNameWithoutApostrophe = '',
                queryWithoutApostrophe = query.replaceAll("’", '').toLowerCase();

                return _.filter(allFirms, (firm)=>{
                    firmName = firm.user.firm_Name;
                    firmNameWithoutApostrophe = firmName?firmName.replaceAll("’", "'").toLowerCase():"";

                    return firmNameWithoutApostrophe.contains(queryWithoutApostrophe);
                });              
            }
        }
    );



// WEBPACK FOOTER //
// ./scripts/shared/filters/firms-type-ahead.js